import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router/router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import './assets/scss/mdi-custom.scss';
import './assets/css/style.css';
import axios from "axios";
import { mapMutations } from "vuex";
import i18n from './i18n'; // Import the i18n configuration

// Redundant image imports removed as they are now served from /public
/*
() => import("./assets/home_1280.webp");
() => import("./assets/course_250.webp");
() => import("./assets/sharing_250.webp");
() => import("./assets/cocktail_250.webp");
() => import("./assets/grazing_250.webp");
() => import("./assets/icons/groceries.webp");
() => import("./assets/icons/cook.webp");
() => import("./assets/icons/serve.webp");
() => import("./assets/icons/clean.webp");
*/

// VideoBackground removed as it is no longer used
// import VideoBackground from 'vue-responsive-video-background-player'
// Vue.component('video-background', VideoBackground);

let VueGtag;
new Promise((resolve) => {
    const VueGtagImport = import('vue-gtag');
    VueGtagImport.then(obj => {
        VueGtag = obj;
        resolve();
    });
}).then(() => {
    Vue.use(VueGtag, {
        appName: 'Kootto-webapp-uat',
        pageTrackerEnabled: true,
        pageTrackerScreenviewEnabled: true,
        config: {
            id: process.env.VUE_APP_ANALYTICS_KEY
        }
    })
})

// import VueGtag from "vue-gtag"
// // console.log("Analytics" + process.env.VUE_APP_ANALYTICS_KEY);
// Vue.use(VueGtag, {
//     appName: 'Kootto-webapp-uat',
//     pageTrackerScreenviewEnabled: true,
//     config: {
//         id: process.env.VUE_APP_ANALYTICS_KEY
//     }
// }, router)

// import VueResource from 'vue-resource'
// Vue.use(VueResource);

// import colors from 'vuetify/lib/util/colors'

// not sure if the following works for stripe
import LoadScript from 'vue-plugin-load-script'
// import Constants from "@/constants";
Vue.use(LoadScript)

// import { StripePlugin } from '@vue-stripe/vue-stripe';
// console.log("Stripe" + process.env.VUE_APP_STRIPE_API_KEY);
// const options = {
//     //pk: "pk_test_51J8OdNAGb7MTLpmkowUVyVsfWEUSx6R98IGrcoqG6QnKOuPGBozH0RECZGhDess3WLvOIkJrD6NaIrzpDNEeOf0Q00vuPGeSiG",
//     pk: process.env.VUE_APP_STRIPE_API_KEY,
//     // stripeAccount: process.env.STRIPE_ACCOUNT,
//     // apiVersion: process.env.API_VERSION,
//     // locale: process.env.LOCALE,
// };
//
// new Promise((resolve) => {
//     let script = document.createElement('script')
//     script.onload = () => {
//         resolve();
//     }
//     // script.async = true;
//     script.defer = true;
//     script.src = 'https://js.stripe.com/v3';
//     document.head.appendChild(script);
// }).then(()=>{
//     Vue.use(StripePlugin, options);
// })



// import VStripeElements from 'v-stripe-elements/lib'
// // and register it
// Vue.use(VStripeElements)

// https://github.com/craigh411/vue-star-rating/
// import StarRating from 'vue-star-rating'
// import AboutChef from './components/AboutChef';
// import Navigation from './components/Navigation';
// import Snackbar from './components/Snackbar';
// Vue.component('star-rating', StarRating);
// Vue.component('about-chef', AboutChef);
// Vue.component('navigation', Navigation);
// Vue.component('snackbar', Snackbar);

// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
// import 'leaflet/dist/leaflet.css';
// import { Icon } from 'leaflet';
//
// delete Icon.Default.prototype._getIconUrl;
// Icon.Default.mergeOptions({
//     iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//     iconUrl: require('leaflet/dist/images/marker-icon.png'),
//     shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });
//
// Vue.component('l-map', LMap);
// Vue.component('l-tile-layer', LTileLayer);
// Vue.component('l-marker', LMarker);

Vue.config.productionTip = false;
Vue.prototype.$log = console.log.bind(console);

var env = process.env.VUE_APP_ENV
console.log(process.env.VUE_APP_ENV);

if (env === "prod") {
    console.log = function () { };
}

axios.defaults.withCredentials = true;

const selectedCountry = localStorage.getItem('selectedCountry') !== null ? localStorage.getItem('selectedCountry') : undefined;
const selectedCountryResult = selectedCountry /*? JSON.parse(selectedCountry).flag.toLowerCase() : undefined;  //'au'*/
console.log('selectedCountry', selectedCountry)
console.log('selectedCountry', selectedCountryResult)

// To extract only the language part:
const browserLocale = navigator.language || navigator.userLanguage;
console.log(browserLocale); // Example output: "en-US"

const languageBrowser = browserLocale.split('-')[0];
const countryBrowser = browserLocale.split('-')[1] || "AU";
console.log(languageBrowser); // Example output: "en"
console.log(countryBrowser); // Example output: "US"

// if empty check the cookie for the language-country and set it to that
// if no cookies set it to the default locale of the browser
let defaultCountry = countryBrowser;
if (selectedCountryResult !== undefined) {
    defaultCountry = selectedCountryResult;
}
console.log('Default country:', defaultCountry);

const availableCountries = ['AU']; //['AU', 'US', 'GB'];
const availableLanguages = ['en']; //['en', 'fr'];

defaultCountry = (availableCountries.includes(defaultCountry.toUpperCase()) ? defaultCountry.toUpperCase() : "AU");

// This is a global mixin, it is applied to every vue instance
Vue.mixin({
    data: function () {
        return {
            appName: 'KOOTTO private chef',
            languageBrowser: languageBrowser,
            countryBrowser: countryBrowser,
            availableCountries: availableCountries,
            availableLanguages: availableLanguages,
            country: defaultCountry,
            showDrawerDashboard: false,
            showChangePWD: false,
            showLogin: false,
            showSignup: false,
            showSignupChef: false,
            showContactUs: false,
            showLanguageCountryPopup: false,
            showProfilePrompt: false,
            appVersion: require('../package.json').version,
            formData: {
                date: undefined,
                time: undefined,
                location: undefined,
                locationItems: undefined,
                geolocation: undefined,
                style: undefined,
                type: undefined,
                preference: undefined,
                guests: undefined
            },
            actionAfterLogin: undefined,
            datepicker: false,
            times: {
                type: Array,
                default: () => [
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ],
                lunchTime: () => [
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30'
                ],
                dinnerTime: () => [
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ]
            },
            guestNumber: {
                type: Array,
                default: () => [
                    0,
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
                ],
                wo0: () => [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
                ]
            },
            languages: {
                type: Array,
                default: () => [
                    "English", "French", "Spanish", "Italian", "German", "Chinese", "Japanese"
                ],
            },
            serviceSelected: undefined,
            chefSelected: undefined,
            // Booking
            dishesSelected: [],
            dishesCheckboxesSelected: [],
            nbKids: undefined,
            nbGuests: undefined,
            comment: undefined,
            bookingToLoad: undefined,
        }
    },
    methods: {
        ...mapMutations(["showSnackbar", "closeSnackbar"]),
        getParameterValue(name) {
            if (this.$store.state.parameters) {
                let param = this.$store.state.parameters.find(value => value.name.name === name);
                if (param) {
                    return param.value;
                }
            }
            return '...';
        },

        getPriceWithCommission(price) {
            let commission = this.$store.state.parameters.find(value => value.name.name == "COMMISSION").value
            // this.$store.state.commission
            // not more rounding to the closes .5 anymore
            // return Math.round((parseFloat(price) * (1+commission/100) )*10/5)*5/10
            return this.roundToXDigits(parseFloat(price) * (1 + commission / 100), 2);
            // return (Math.round((parseFloat(price) * (1+commission/100) )*100)/100);
        },
        getPriceWithCommission2(price, commission) {
            // not more rounding to the closes .5 anymore
            // return Math.round((parseFloat(price) * (1+commission/100) )*10/5)*5/10
            return this.roundToXDigits(Math.round((parseFloat(price) * (1 + commission / 100)) * 100) / 100, 2)
        },
        getPriceWithoutCommission2(price, commission) {
            // not more rounding to the closes .5 anymore
            // return Math.round((parseFloat(price) * (1+commission/100) )*10/5)*5/10
            return this.roundToXDigits(Math.round((parseFloat(price) / (1 + commission / 100)) * 100) / 100, 2)
        },
        findEventTime(name) {
            if (this.eventTime !== undefined) {
                return this.eventTime.find(s => s.name === name);
            }
        },
        roundToXDigits(value, digits) {
            if (!digits) {
                digits = 2;
            }
            value = value * Math.pow(10, digits);
            value = Math.round(value);
            value = value / Math.pow(10, digits);
            return value;
        },
        formatPrice(value) {
            if (isNaN(value)) {
                return "";
            }
            return value.toLocaleString(undefined, { minimumFractionDigits: 2 })
        },
        itemTitle(category, item) {
            let title = "";
            title += item.description;
            if (category.pricingType.name === "UNIT") {
                title += " x" + item.qty;
            }
            return title;
        },
        totalItem(category, item) {
            let total = 0;
            if (category.pricingType.name === "UNIT") {
                total += this.getPriceWithCommission(item.price) * item.qty;
            } else {
                if (category.categoryType.name === 'KID' && this.$root.nbKids > 0) {
                    total += this.getPriceWithCommission(item.price) * this.$root.nbKids;
                } else if (category.categoryType.name !== 'KID' && this.$root.nbGuests > 0) {
                    total += this.getPriceWithCommission(item.price) * this.$root.nbGuests;
                }
            }
            return this.roundToXDigits(total, 2);
        },
        categoryTitle(category) {
            let title = "";
            title += category.name;
            if (category.pricingType.name === "PERSON") {
                if (category.categoryType.name === 'KID' && this.$root.nbKids > 0) {
                    title += " x" + this.$root.nbKids;
                } else if (category.categoryType.name !== 'KID' && this.$root.nbGuests > 0) {
                    title += " x" + this.$root.nbGuests;
                }
            }
            return title;
        },
        totalCategory(category) {
            let total = 0;
            if (category.multiSelect) {
                for (var i = 0; i < this.$root.dishesSelected[category.name].length; i++) {
                    if (category.pricingType.name === "UNIT") {
                        total += this.getPriceWithCommission(this.$root.dishesSelected[category.name][i].price) * this.$root.dishesSelected[category.name][i].qty;
                    } else {
                        if (category.categoryType.name !== 'KID' && this.$root.nbGuests > 0) {
                            total += this.getPriceWithCommission(this.$root.dishesSelected[category.name][i].price) * this.$root.nbGuests;
                        }
                    }
                }
            } else {
                if (category.pricingType.name === "UNIT") {
                    total += this.getPriceWithCommission(this.$root.dishesSelected[category.name].price) * this.$root.dishesSelected[category.name].qty;
                } else {
                    if (category.categoryType.name !== 'KID' && this.$root.nbGuests > 0) {
                        total += this.getPriceWithCommission(this.$root.dishesSelected[category.name].price) * this.$root.nbGuests;
                    }
                }
            }
            return this.roundToXDigits(total, 2);
        },
        total() {
            let total = 0;
            let totalDishes = 0;
            // let waiterPrice=this.waiterPrice();
            // let minChef=this.minChef();
            if (this.$root.packageSelected == null || this.$root.packageSelected === undefined) {
                for (const categoryName in this.$root.dishesSelected) {
                    let category = this.serviceSelectedCd.itemCategories.find(c => c.name === categoryName);
                    if (this.$root.dishesSelected[categoryName] !== undefined && this.$root.dishesSelected[categoryName].length !== undefined) {
                        for (const dishIndex in this.$root.dishesSelected[categoryName]) {
                            const dish = this.$root.dishesSelected[categoryName][dishIndex];
                            if (category.pricingType.name === "PERSON") {
                                if (this.$root.nbGuests != null) {
                                    total += this.getPriceWithCommission(dish.price) * this.$root.nbGuests;
                                    if (category.categoryType.name !== 'OTHER') {
                                        totalDishes += this.$root.nbGuests;
                                    }
                                }
                            } else if (category.pricingType.name === "UNIT") {
                                total += this.getPriceWithCommission(dish.price) * dish.qty;
                                if (category.categoryType.name !== 'OTHER') {
                                    totalDishes += dish.qty;
                                }

                            }
                        }
                    } else if (this.$root.dishesSelected[categoryName] !== undefined && category) {
                        const dish = this.$root.dishesSelected[categoryName];
                        if (category.pricingType.name === "PERSON") {
                            if (this.$root.nbGuests != null) {
                                total += this.getPriceWithCommission(dish.price) * this.$root.nbGuests;
                                if (category.categoryType.name !== 'OTHER') {
                                    totalDishes += this.$root.nbGuests;
                                }
                            }
                        } else if (category.pricingType.name === "UNIT") {
                            total += this.getPriceWithCommission(dish.price) * dish.qty;
                            if (category.categoryType.name !== 'OTHER') {
                                totalDishes += dish.qty;
                            }
                        }
                    }
                }
                if (this.serviceSelectedCd.minWaiterDishes !== undefined && totalDishes >= this.serviceSelectedCd.minWaiterDishes) {
                    this.waiterPrice = this.roundToXDigits(this.getPriceWithCommission(this.serviceSelectedCd.waiterPrice), 2);
                    total += this.waiterPrice;
                } else {
                    this.waiterPrice = undefined;
                }
            } else {
                total = this.getPriceWithCommission(this.$root.packageSelected.price) * this.$root.nbGuests;
            }

            if (this.serviceSelectedCd.minPrice !== undefined && total < this.getPriceWithCommission(this.serviceSelectedCd.minPrice)) {
                this.minChef = this.roundToXDigits(this.getPriceWithCommission(this.serviceSelectedCd.minPrice) - total, 2);
                total += this.minChef;
            } else {
                this.minChef = undefined;
            }

            return this.roundToXDigits(total, 2);

        },
        round(num, dec) {
            num = Math.round(num + 'e' + dec)
            return Number(num + 'e-' + dec)
        },
        getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
            let R = 6371; // Radius of the earth in km
            let dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
            let dLon = this.deg2rad(lon2 - lon1);
            let a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
            let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            let d = R * c; // Distance in km
            return d;
        },
        deg2rad(deg) {
            return deg * (Math.PI / 180)
        },
        log(param) {
            if (process.env.VUE_APP_ENV !== "prod") {
                console.log(param);
            }

        },
        openSignup(chef) {
            let screenview = {
                app_name: process.env.VUE_APP_ANALYTICS_NAME,
                screen_name: 'Signup Chef',
                page_title: 'Kootto - Signup Chef',
            };
            if (localStorage && localStorage.getItem("campaign") !== undefined) {
                screenview.campaign = localStorage.getItem("campaign");
            }
            if (chef) {
                this.$root.showSignupChef = chef;
                screenview.page_title = 'Kootto - Signup Chef';
                this.$gtag.screenview(screenview);

            } else {
                this.$root.showSignupChef = chef;
                screenview.page_title = 'Kootto - Signup';
                this.$gtag.screenview(screenview);
            }
            this.$root.showSignup = true;
        },
        checkTodoAction() {
            if (this.$root.actionAfterLogin !== undefined && this.$root.actionAfterLogin === "LOAD_BOOKING") {
                if (this.$store.state.loggedin == true) {
                    this.$root.actionAfterLogin = undefined;
                    if (this.$store.state.isAdmin == true) {
                        this.$router.push({ path: `/admin/bookings` })
                    } else if (this.$store.state.isChef == true) {
                        this.$router.push({ path: `/dashboard/bookings` })
                    } else {
                        this.$router.push("/account/bookings");
                    }
                } else {
                    let error = "Please login to see your booking ";
                    this.showSnackbar({ text: error, color: "error" });
                    this.$root.showLogin = true;
                }
            }
        },
        formatPackageMinMaxGuests(pack) {
            if (pack != undefined && (pack.minGuests === undefined || pack.minGuests === 0 || pack.minGuests === "") && pack.maxGuests != undefined && pack.maxGuests != "") {
                return "(0 - " + pack.maxGuests + " Guests)";
            } else if (pack != undefined && pack.minGuests !== undefined && pack.minGuests !== 0 && pack.minGuests !== "" && pack.maxGuests == undefined || pack.maxGuests == "") {
                return "(" + pack.minGuests + " Guests minimum)";
            } else if (pack != undefined && pack.minGuests !== undefined && pack.minGuests !== 0 && pack.minGuests !== "" && pack.maxGuests != undefined && pack.maxGuests != "") {
                return "(" + pack.minGuests + " - " + pack.maxGuests + " Guests)";
            } else {
                return "";
            }
        },
        formatPackageCategorySelection(cat) {
            if (cat.selectionType.name == "SINGLE") {
                return "Single Choice";
            } else if (cat.selectionType.name == "MULTIPLE") {
                let text = "Multiple choice ";
                let min = "";
                let max = "";
                if (cat.minItem != undefined && cat.minItem != 0 && cat.minItem != "") {
                    min += " from " + cat.minItem;
                }
                // else if ( (cat.minItem == undefined || cat.minItem == 0 || cat.minItem == "" ) && (cat.maxItem !== undefined && cat.maxItem !== 0 && cat.maxItem !== "") ){
                //   text += " ( " + cat.maxItem +" maximum )"
                // }else if ( (cat.minItem != undefined && cat.minItem != 0 && cat.minItem != "" ) && (cat.maxItem !== undefined && cat.maxItem !== 0 && cat.maxItem !== "") ){
                //   text += " ( " + cat.minItem + " - " + cat.maxItem +" )"
                // }
                if (cat.maxItem !== undefined && cat.maxItem !== 0 && cat.maxItem !== "") {
                    max += " up to " + cat.maxItem;
                }
                if (min != "" && max != "") {
                    text += "( " + min + " " + max + " )";
                }

                if (min != "" && max == "") {
                    text += "( " + cat.minItem + " Minimum )";
                }

                if (min == "" && max != "") {
                    text += "( " + max + " )";
                }

                return text;
            } else if (cat.selectionType.name == "ALL_INCLUSIVE") {
                return "All Inclusive";
            } else {
                return "";
            }
        },
        formatItemRestrictions(item) {
            var result = "";
            var restrictions = [];
            if (item.min && item.min > 0) {
                restrictions.push("Min: " + item.min);
            }
            if (item.max) {
                restrictions.push("Max:" + item.max);
            }
            if (restrictions.length > 0) {
                result += " (" + restrictions.join(", ") + ")"
            }
            return result;
        },
        packageCategoriesSorted(pack) {
            if (pack != undefined && pack.packageCategories !== undefined) {
                return pack.packageCategories.slice().sort(((a, b) => a.itemCategory.ordering - b.itemCategory.ordering));
            } else {
                return undefined;
            }
        },
        filteredDishesByCategoryForPackages(service, packageCategory) {
            if (packageCategory.limitedItems != undefined && packageCategory.limitedItems.length > 0) {
                return packageCategory.limitedItems;
            } else {
                if (service !== undefined && packageCategory !== undefined & service.dishes != undefined) {
                    return service.dishes.filter(d => d.itemCategory !== undefined && d.itemCategory.name === packageCategory.itemCategory.name)
                } else {
                    return [];
                }
            }
        },
    },
    computed: {
        isChef() {
            return this.$store.state.isChef;
        },
        isAdmin() {
            return this.$store.state.isAdmin;
        },
        eventTime() {
            // excluding morning for now
            if (this.$store.state.eventTime) {
                return this.$store.state.eventTime.filter(s => s.name !== "BREAKFAST");
            }
            return undefined;
        },
        eventStatus() {
            if (this.$store.state.eventStatus) {
                return this.$store.state.eventStatus.filter(s => s.name !== "RESERVED");
            } else {
                return this.$store.state.eventType;
            }
        },
        loggedin() {
            // console.log(this.$store.state.loggedin);
            return this.$store.state.loggedin;
        }
    },
    watch: {
    }
});

// const DEFAULT_TITLE = 'Kootto';
router.afterEach((to) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        let title = to.meta.title;

        // Check if title is a function and call it with the route object
        if (typeof title === 'function') {
            title = title(to);
        } else if (typeof title === 'string') {
            // Handle string titles with replacements
            if (to.params.city !== undefined) {
                title = title.replaceAll("Australia", to.params.city);
            }
            if (to.params.name !== undefined) {
                title += to.params.name;
            }
        }

        document.title = title /*|| DEFAULT_TITLE*/;

    });
});

// This callback runs before every route change, including on page load.
// Update the navigation guard to handle empty locale patterns
router.beforeEach((to, from, next) => {

    // Add a global navigation guard to detect language-country from the path and set i18n.locale
    const localePattern = /^[a-z]{2}-[a-z]{2}$/i;
    let locale = to.params.language_country;
    const localeFromPathMatch = to.path.match(/^\/([a-z]{2}-[a-z]{2})(?=\/|$)/i);
    const localeFromPath = localeFromPathMatch ? localeFromPathMatch[1] : undefined;

    // Some catch-all matches can place the locale into pathMatch instead of params.
    if (!locale && localeFromPath) {
        locale = localeFromPath;
    }

    console.log('Locale from url', locale);
    console.log('Locale set to:', i18n.locale);
    console.log('from:', from);
    console.log('to:', to);
    console.log('to.path:', to.path);

    console.log('to.params:', to.params);

    const selectedCountry = localStorage.getItem('selectedCountry') !== null ? localStorage.getItem('selectedCountry') : undefined;
    const selectedLanguage = localStorage.getItem('selectedLanguage') !== null ? localStorage.getItem('selectedLanguage') : undefined;

    if (locale && localePattern.test(locale)) {
        if (!availableLanguages.includes(locale.split('-')[0]) || !availableCountries.includes(locale.split('-')[1].toUpperCase())) {
            const fallbackLocale = (availableLanguages.includes(i18n.locale) ? i18n.locale : "en") + "-" + (availableCountries.includes(defaultCountry.toUpperCase()) ? defaultCountry.toUpperCase() : "AU");
            const newPath = localeFromPath
                ? to.path.replace(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i, `/${fallbackLocale}`)
                : to.path.replace(to.params.language_country, fallbackLocale);
            return next({ path: newPath, query: to.query });
        }
        i18n.locale = locale.split('-')[0]; // Set the i18n locale
        console.log('Locale set to:', i18n.locale);
    } else if (selectedLanguage !== undefined && selectedCountry !== undefined) {
        // Keep route as-is (no redirect) and apply locale in app state.
        locale = (availableLanguages.includes(selectedLanguage) ? selectedLanguage : "en") + "-" + (availableCountries.includes(selectedCountry.toUpperCase()) ? defaultCountry.toUpperCase() : "AU");
        i18n.locale = locale.split('-')[0];
        next({ path: "/" + locale + to.path, query: to.query });
    }
    else {
        // Keep route as-is (no redirect) and fall back to default locale in app state.
        locale = (availableLanguages.includes(i18n.locale) ? i18n.locale : "en") + "-" + (availableCountries.includes(defaultCountry.toUpperCase()) ? defaultCountry.toUpperCase() : "AU");
        i18n.locale = locale.split('-')[0];
        next({ path: "/" + locale + to.path, query: to.query });
    }

    // console.log(window.location.origin+ to.path);
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
    // `/nested`'s will be chosen.
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    // Title can be a string or a function that receives the route object.
    if (nearestWithTitle) {
        const title = nearestWithTitle.meta.title;
        document.title = typeof title === 'function' ? title(to) : title;
    } else if (previousNearestWithMeta) {
        const title = previousNearestWithMeta.meta.title;
        document.title = typeof title === 'function' ? title(to) : title;
    }

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

    const el = document.querySelectorAll('[data-vue-router-canonical]');
    // console.log(el[0]);
    // let fullpath=(window.location.origin+ to.path).replaceAll("www.","");

    // Calculate the clean path (no locale prefix) for canonical and hreflang links
    let cleanPath = to.path;
    const localeMatch = cleanPath.match(/^\/([a-z]{2}-[a-z]{2})(?:\/|$)/i);
    if (localeMatch) {
        cleanPath = cleanPath.replace(/^\/[a-z]{2}-[a-z]{2}(?:\/|$)/i, '/');
    }
    if (cleanPath === '' || cleanPath === '/') {
        cleanPath = '/';
    }

    // Set canonical URL to clean path without locale prefix
    let canonicalUrl = window.location.origin + to.path;
    if (el[0]) {
        el[0].href = canonicalUrl;
    }

    // Set hreflang tags
    const hreflangEnAu = document.querySelectorAll('[data-vue-router-hreflang-en-au]');
    const hreflangDefault = document.querySelectorAll('[data-vue-router-hreflang-default]');

    // For current locale (en-AU) - must point to the canonical URL of the localized version
    if (hreflangEnAu[0]) {
        hreflangEnAu[0].href = window.location.origin + '/en-AU' + (cleanPath === '/' ? '/' : cleanPath);
    }

    // For x-default (fallback), use the clean URL without locale
    // Note: While this redirects, it is correct for x-default fallback behavior.
    if (hreflangDefault[0]) {
        hreflangDefault[0].href = window.location.origin + (cleanPath === '/' ? '' : cleanPath);
    }

    const ogUrl = document.querySelectorAll('[data-vue-router-og-url]');
    ogUrl[0].content = window.location.origin + to.path;

    const ogImage = document.querySelectorAll('[data-vue-router-og-image]');
    // ogImage[0].content=(window.location.origin).replaceAll("www.","") + require("./assets/home_1920.webp");
    ogImage[0].content = (window.location.origin) + require("./assets/home_1920.webp");

    const ogTitle = document.querySelectorAll('[data-vue-router-og-title]');
    ogTitle[0].content = document.title;

    // Update Twitter Card title and image
    const twitterTitle = document.querySelectorAll('[data-vue-router-twitter-title]');
    if (twitterTitle[0]) {
        twitterTitle[0].content = document.title;
    }

    const twitterImage = document.querySelectorAll('[data-vue-router-twitter-image]');
    if (twitterImage[0]) {
        twitterImage[0].content = (window.location.origin) + require("./assets/home_1920.webp");
    }

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags.map(tagDef => {
        const tag = document.createElement('meta');

        Object.keys(tagDef).forEach(key => {
            let value = tagDef[key];

            // Check if the value is a function and call it with the route object
            if (typeof value === 'function') {
                value = value(to);
            }

            tag.setAttribute(key, value);
        });

        // We use this to track which meta tags we create so we don't interfere with other ones.
        tag.setAttribute('data-vue-router-controlled', '');

        return tag;
    })
        // Add the meta tags to the document head.
        .forEach(tag => document.head.appendChild(tag));

    // Update twitter:description AFTER route meta tags are in the DOM so og:description exists
    const twitterDescription = document.querySelectorAll('[data-vue-router-twitter-description]');
    if (twitterDescription[0]) {
        const ogDesc = document.querySelectorAll('[data-vue-router-controlled][property="og:description"]');
        if (ogDesc.length > 0) {
            twitterDescription[0].content = ogDesc[0].content;
        }
    }

    // track pages
    let screenview = {
        app_name: process.env.VUE_APP_ANALYTICS_NAME,
        page_title: document.title,
        page_path: to.path,
    };
    if (localStorage && localStorage.getItem("campaign") !== undefined) {
        screenview.campaign = localStorage.getItem("campaign");
    }
    // if (Vue.$gtag){
    //     Vue.$gtag.screenview(screenview);
    // }


    // Update <meta http-equiv="Content-Language">
    const metaContentLanguage = document.querySelector('meta[http-equiv="Content-Language"]');
    if (metaContentLanguage) metaContentLanguage.setAttribute('content', locale);
    // Update <html lang> attribute
    document.documentElement.lang = i18n.locale;

    // Update <meta name="locale"> and <meta property="og:locale">
    const metaLocale = document.querySelector('meta[name="locale"]');
    if (metaLocale) metaLocale.setAttribute('content', locale);

    const ogLocale = document.querySelector('meta[property="og:locale"]');
    if (ogLocale) ogLocale.setAttribute('content', locale.replace('-', '_'));
    next();
});

new Vue({
    router,
    store,
    vuetify,
    i18n, // Add the i18n instance here
    render: h => h(App)
}).$mount("#app");